import createIcon from '../../createIcon';

/**
 * @component @name BookmarkAdded
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMTE1MiAyMS4xODVMMTAuMTE1MiAxOC4xODVMMy4xMTUyMyAyMS4xODVWNS4xODVDMy4xMTUyMyA0LjA4NSA0LjAxNTIzIDMuMTg1IDUuMTE1MjMgMy4xODVIMTIuMTE1MkMxMS40ODUyIDQuMDI1IDExLjExNTIgNS4wNTUgMTEuMTE1MiA2LjE4NUMxMS4xMTUyIDguOTQ1IDEzLjM1NTIgMTEuMTg1IDE2LjExNTIgMTEuMTg1QzE2LjQ1NTIgMTEuMTg1IDE2Ljc5NTIgMTEuMTU1IDE3LjExNTIgMTEuMDg1VjIxLjE4NVpNMTUuOTQ1MiA5LjE4NUwxMy4xMTUyIDYuMzU1TDE0LjUyNTIgNC45NDVMMTUuOTM1MiA2LjM1NUwxOS40NzUyIDIuODE1TDIwLjg4NTIgNC4yMjVMMTUuOTQ1MiA5LjE4NVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BookmarkAdded = createIcon('BookmarkAdded', [
  [
    'path',
    {
      d: 'M17.1152 21.185L10.1152 18.185L3.11523 21.185V5.185C3.11523 4.085 4.01523 3.185 5.11523 3.185H12.1152C11.4852 4.025 11.1152 5.055 11.1152 6.185C11.1152 8.945 13.3552 11.185 16.1152 11.185C16.4552 11.185 16.7952 11.155 17.1152 11.085V21.185ZM15.9452 9.185L13.1152 6.355L14.5252 4.945L15.9352 6.355L19.4752 2.815L20.8852 4.225L15.9452 9.185Z',
      key: '1fn94e',
    },
  ],
]);

export default BookmarkAdded;
